import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css'],
  standalone: false,
})
export class MainMenuComponent {
  constructor(public router: Router) {}

  ngOninit(): void {
    this.toLogout();
  }

  toLogout(): void {
    localStorage.clear();
    this.router.navigate(['./login']);
  }
}
